import { render } from "./EventsList.vue?vue&type=template&id=0f12ee7a&scoped=true&ts=true"
import script from "./EventsList.vue?vue&type=script&lang=ts"
export * from "./EventsList.vue?vue&type=script&lang=ts"

import "./EventsList.vue?vue&type=style&index=0&id=0f12ee7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f12ee7a"]])

export default __exports__